import { forwardRef } from 'react';
import { createPortal } from 'react-dom';
import cx from 'classnames';
import { getDragPreviewRoot } from '.';
import { useReactDndConstructs } from '../../../dnd/ReactDndContext';
import { getDndDesignTokens } from '../../../style/reactDnd/DndStyleTokens';
import { useDesignTokens, useGlobalDesignTokens } from '../../../theme';
import cn from './DragPreview.css.json';
import './DragPreview.css';
import { jsx as _jsx } from "react/jsx-runtime";
function getDraggingStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }
  const transform = `translate(${currentOffset.x}px, ${currentOffset.y}px)`;
  return {
    transform
  };
}
export const DragPreview = /*#__PURE__*/forwardRef((props, ref) => {
  const dt = useDesignTokens();
  const globalDesignTokens = useGlobalDesignTokens();
  const {
    useDragLayer
  } = useReactDndConstructs();
  const {
    isDragging,
    currentOffset
  } = useDragLayer(monitor => ({
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset()
  }));
  const tokens = {
    ...getDndDesignTokens(dt),
    ...props.theme?.(dt)
  };
  if (!isDragging) return null;
  return /*#__PURE__*/createPortal( /*#__PURE__*/_jsx("div", {
    ref: ref,
    "data-testid": props.testId,
    className: cx(cn.dragImagePreview, props.className),
    style: {
      ...getDraggingStyles(currentOffset),
      ...globalDesignTokens,
      ...tokens,
      ...props.style
    },
    children: props.children
  }), getDragPreviewRoot());
});
//# sourceMappingURL=DragPreview.js.map